import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Outlet, useLoaderData, useLocation } from "react-router-dom";

import CreateGameButton from "./components/CreateGameButton";

import Schedule from "../../../../components/Schedule";
import { selectSelectedTeam } from "../../../../features/clubhouse/clubhouseSlice";
import { selectSetting } from "../../../../features/global/globalSlice";
import { selectSelectedLeague } from "../../../../features/leaguemgmt/leagueManagementSlice";
import { useAppSelector } from "../../../../hooks/reduxHooks";
import { IGame, ISiteSetting, ITeamSchedule } from "../../../../types/api";

const ClubhouseTeamSchedule = (): React.JSX.Element => {
    const { schedule: loadedSchedule } = useLoaderData() as {
        schedule: ITeamSchedule | null;
    };
    const currentTeam = useAppSelector(selectSelectedTeam);
    const currentLeague = useAppSelector(selectSelectedLeague);

    const { setting: youthDeleteLink } = useAppSelector(state =>
        selectSetting(state, "majorybl_display_delete_game_link_for_coaches"),
    ) as ISiteSetting;
    const { setting: hsDeleteLink } = useAppSelector(state =>
        selectSetting(
            state,
            "majorybl_hs_display_delete_game_link_for_coaches",
        ),
    ) as ISiteSetting;
    const deleteLink =
        currentLeague?.season === "Youth" ? youthDeleteLink : hsDeleteLink;

    const location = useLocation();
    const isOnSchedulePage = /coachs-clubhouse\/team\/\d+\/schedule?$/.test(
        location.pathname,
    );
    const [schedule, setSchedule] = useState<IGame[]>(
        loadedSchedule?.games || [],
    );

    const scheduled = schedule?.filter(g => !["Postponed"].includes(g.status));
    const postponed = schedule?.filter(g => g.status === "Postponed");

    return isOnSchedulePage ? (
        <Container
            data-testid="clubhouseTeamScheduleContent"
            className="clubhouseTeamScheduleContent"
        >
            <CreateGameButton currentTeam={currentTeam} />
            {scheduled.length === 0 && postponed.length === 0 ? (
                <Row>
                    <Col>
                        <h2>No scheduled games</h2>
                    </Col>
                </Row>
            ) : (
                <React.Fragment>
                    {scheduled.length > 0 && (
                        <Row>
                            <Col>
                                <Schedule
                                    schedule={scheduled as IGame[]}
                                    displayDeleteLink={deleteLink}
                                    setSchedule={setSchedule}
                                    scheduleHeader="Team Schedule"
                                    showButtons={true}
                                    scheduleType="team"
                                />
                            </Col>
                        </Row>
                    )}
                    {postponed.length > 0 && (
                        <Row>
                            <Col>
                                <Schedule
                                    schedule={postponed}
                                    displayDeleteLink={deleteLink}
                                    setSchedule={setSchedule}
                                    scheduleHeader="Postponed Games"
                                    showButtons={true}
                                    scheduleType="team"
                                />
                            </Col>
                        </Row>
                    )}
                </React.Fragment>
            )}
        </Container>
    ) : (
        <Outlet context={{ schedule, setSchedule }} />
    );
};

export default ClubhouseTeamSchedule;
